import { z } from 'zod';
import { DateTimeSchema, objectIdRef, ObjectIdSchema, ObjectIdString } from '../common.js';

export const AccountStatus = z.enum(['active', 'disabled', 'terminated', 'deleted']);
export type AccountStatus = z.infer<typeof AccountStatus>;

export const IAccount = z.object({
  _id: ObjectIdSchema,
  name: z.string(),
  status: AccountStatus.default('active'),
  emailDomains: z.string().array().default([]),
  isInternal: z.boolean().default(false),
  primaryIntegration: objectIdRef('Integration').nullish(),
  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IAccount = z.infer<typeof IAccount>;

export const AccountDTO = IAccount.omit({
  _id: true,
  createdAt: true,
  updatedAt: true,
  primaryIntegration: true,
}).safeExtend({
  _id: ObjectIdString,
  createdAt: DateTimeSchema.nullish(),
  updatedAt: DateTimeSchema.nullish(),
});
export type AccountDTO = z.infer<typeof AccountDTO>;

export const ConfigurableAccountFields = IAccount.pick({
  status: true,
  emailDomains: true,
  isInternal: true,
}).safeExtend({ primaryIntegration: ObjectIdString.nullish(), name: z.string().default('') });
export type ConfigurableAccountFields = z.infer<typeof ConfigurableAccountFields>;

// ConfigurableAccountFields other than primaryIntegration
export const AccountCreateSchema = ConfigurableAccountFields.omit({ primaryIntegration: true });

// ConfigurableAccountFields with all defaults removed
export const AccountUpdateParams = ConfigurableAccountFields.required().partial();
export type AccountUpdateParams = z.infer<typeof AccountUpdateParams>;
